import React from "react";
import "./CustomPagination.css";

const CustomPagination = ({
 currentPage,
 totalPages,
 onPageChange,
 perPage,
 totalCount,
}) => {
 const handlePrevious = () => {
  if (currentPage > 1) {
   onPageChange(currentPage - 1);
  }
 };

 const handleNext = () => {
  if (currentPage < totalPages) {
   onPageChange(currentPage + 1);
  }
 };

 const handlePageClick = (page) => {
  if (page !== currentPage) {
   onPageChange(page);
  }
 };

 const renderPagination = () => {
  const pages = [];
  const range = 2;

  if (totalPages <= 10) {
   for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
   }
  } else {
   pages.push(1, 2);

   if (currentPage > range + 3) {
    pages.push("...");
   }

   for (
    let i = Math.max(3, currentPage - range);
    i <= Math.min(totalPages - 2, currentPage + range);
    i++
   ) {
    pages.push(i);
   }

   if (currentPage < totalPages - (range + 2)) {
    pages.push("...");
   }

   pages.push(totalPages - 1, totalPages);
  }

  return pages.map((page, index) => {
   const isActive = currentPage === page;

   return (
    <li key={index} className={`page-item ${isActive ? "active" : ""}`}>
     {page === "..." ? (
      <span className="page-link">...</span>
     ) : (
      <button className="page-link" onClick={() => handlePageClick(page)}>
       {page}
      </button>
     )}
    </li>
   );
  });
 };

 return (
  <div className="pagination-container">
   <p className="pagination-info">
    Showing {(currentPage - 1) * perPage + 1} to{" "}
    {Math.min(currentPage * perPage, totalCount)} of {totalCount} entries
   </p>
   <ul className="pagination">
    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
     <button className="page-link" onClick={handlePrevious}>
      {"<"}
     </button>
    </li>

    {renderPagination()}

    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
     <button className="page-link" onClick={handleNext}>
      {">"}
     </button>
    </li>
   </ul>
  </div>
 );
};

export default CustomPagination;
